import DOMPurify from "dompurify";

// Staging `banner.html` is announcement copy: <center>, <b>, <h3>, and
// <div id="advisor_sync_delay">. No iframes, scripts, or images. Keep that
// surface closed so a future banner cannot replay the educational-video miss.
const BANNER_HTML_POLICY = {
  ALLOWED_TAGS: ["a", "b", "br", "center", "div", "em", "h3", "h4", "i", "p", "span", "strong", "u"],
  ALLOWED_ATTR: ["href", "id", "rel", "target"],
};

export function sanitizeBannerHtml(value: unknown): string {
  return DOMPurify.sanitize(typeof value === "string" ? value : "", BANNER_HTML_POLICY);
}
